import { Divider, Typography } from "antd";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import { UserRespose } from "../../redux/Reducer/userReducer";
import {
  getLocalStorageItem,
  localStorageConstants,
} from "../../Services/LocalStorageServices";
import { QueryParams, Routes } from "../../Utils/Constants/routes";
import Account from "../Accounts/Components";
import LinkAccount from "../Accounts/Components/LinkAccount";
import Menubar from "../Common/Components/Menubar";
import ScaffoldComponent from "../Common/Components/ScaffoldComponent";
import ConsentDetails from "../Consent/Components/Details";
import Consent from "../Consent/Components/Home";
import MoreScreen from "../More";
import ChangePassword from "../More/ChangePassword";
import DeleteAccount from "../More/DeleteAccount";
import ReportIssue from "../More/ReportIssue";
import TermsAndConditions from "../More/TAndC";
import PrivacyAndPolicy from "../More/PAndP";
import UserProfile from "../More/UserProfile";
import UserActivityComponent from "../UserActivityComponent";
import "./index.css";
import GrievanceRedressal from "../More/GrievanceRedressal";
import { Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import MobileNumbers from "../More/MobileNumbers";
import AccessibilityControls from "../Common/Components/AccessibilityControls";
import Footer from "../../Footer";
import NotificationPreferences from "../More/UserProfile/notification";

export const RootContext = createContext({});

const Root: React.FC<{ user: UserRespose }> = ({ user }) => {
  const history = useHistory();

  const [header, setHeader] = useState<any>(null);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [headerVisible, setHeaderVisible] = useState(true);
  const [isMenuBarVisible, setIsMenuBarVisible] = useState(true);
  const { t } = useTranslation();

  const setHeaderMethod = useCallback(() => {
    if (user.firstName !== "") {
      setHeader(
        <Typography.Text className="headerText">
          {t("lblHello")} {user.firstName}
        </Typography.Text>
      );
    }
  }, [user.firstName, t]);

  useEffect(() => {
    if (header === null) setHeaderMethod();
  }, [setHeaderMethod, header]);

  useEffect(() => {
    const accessToken = getLocalStorageItem(localStorageConstants.accessToken);

    if (!accessToken) {
      history.push({
        pathname: Routes.login,
        search:
          history.location.pathname !== Routes.login
            ? `?${QueryParams.redirect}=${history.location.pathname}`
            : undefined,
        state: { search: history.location.search },
      });
    }
  });

  const renderConsentDetails = (props: any) => (
    <ConsentDetails
      {...props}
      consentUniqueId={props.match.params.consentUniqueId}
      type={props.match.params.type}
    />
  );

  const redirectLogin = () => <Redirect to={Routes.login} />;

  const redirectConsent = () => <Redirect to={Routes.consent} />;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <RootContext.Provider
      value={{ setHeader, header, setHeaderVisible, setIsMenuBarVisible }}
    >
      <div className="rootLayout">
        {/* {isMenuBarVisible ? <Menubar setHeader={setHeaderMethod} /> : <></>} */}
        {isMenuBarVisible ? (
          <>
            {/* <div className="desktopMenu">
              <Menubar setHeader={setHeaderMethod} />
            </div>

            <Drawer
              placement="left"
              open={mobileMenuVisible}
              onClose={() => setMobileMenuVisible(false)}
              width={260}
              bodyStyle={{ padding: 0 }}
            >
              <Menubar setHeader={setHeaderMethod} />
            </Drawer> */}

            {!isMobile && isMenuBarVisible && (
                <Menubar setHeader={setHeaderMethod} />
              )}

              {isMobile && (
                <Drawer
                  placement="left"
                  open={mobileMenuVisible}
                  onClose={() => setMobileMenuVisible(false)}
                  width={260}
                >
                  <Menubar setHeader={setHeaderMethod} />
                </Drawer>
              )}
          </>
        ) : null}

        <ScaffoldComponent>
          {/* <div className="globalAccessibilityBar">
            <AccessibilityControls />
          </div> */}
          
          {headerVisible ? (
            <>
              {/* <div className="headerRoot">{header}</div> */}
              <Divider className="divider" />
            </>
          ) : (
            <></>
          )}
          
          <div className="mobileHeader">
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileMenuVisible(true)}
            />
          </div>
          <Switch>
            <Route
              exact={true}
              path={Routes.linkAccounts}
              component={LinkAccount}
            />

            <Route exact={true} path={Routes.consent} component={Consent} />
            <Route exact={true} path={Routes.account} component={Account} />
            <Route
              exact={true}
              path={Routes.consentDetails}
              render={renderConsentDetails}
            />

            <Route exact={true} path={Routes.more} component={MoreScreen} />
            <Route
              exact={true}
              path={Routes.more + Routes.termsandconditions}
              component={TermsAndConditions}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.userprofile}
              component={UserProfile}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.changePassword}
              component={ChangePassword}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.reportIssue}
              component={ReportIssue}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.deleteAccount}
              component={DeleteAccount}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.history}
              component={UserActivityComponent}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.privacyandpolicy}
              component={PrivacyAndPolicy}
            />
            <Route
              exact={true}
              path={Routes.more + Routes.grievanceredressal}
              component={GrievanceRedressal}
            />
            {/* <Route
              exact={true}
              path={Routes.more + Routes.mobileNumbers}
              component={MobileNumbers}
            /> */}
            <Route
              exact={true}
              path={Routes.more + Routes.userprofile + Routes.notification}
              component={NotificationPreferences}
            />
            {getLocalStorageItem(localStorageConstants.accessToken)?.length ? (
              <Route path="*" render={redirectConsent} />
            ) : (
              <Route path="*" render={redirectLogin} />
            )}
          </Switch>

          {/* <Footer /> */}
        </ScaffoldComponent>
      </div>
    </RootContext.Provider>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(Root);
